<template>
  <div class="gf-field">
    <input :type="visible?'text':'password'" :placeholder="placeholder" v-model="componentValue" />
    <a href="" class="pass-toggle" @click.prevent="toggleVisible">
      <i class="fa-regular fa-eye" v-if="!visible"></i>
      <i class="fa-regular fa-eye-slash" v-else></i>
    </a>
  </div>
</template>

<script>
import { componentMixin } from './FormCommon'

export default {
  props: ["placeholder"],
  mixins: [componentMixin],
  data: ()=>({
    visible: false,
  }),
  methods: {
    toggleVisible() {
      this.visible=!this.visible;
    },
  },
}
</script>
